import { TelegramWebApp } from '../types';

export const getTelegramWebApp = (): TelegramWebApp | null => {
  return window.Telegram?.WebApp || null;
};

export const initTelegramWebApp = () => {
  const tg = getTelegramWebApp();
  
  if (tg) {
    tg.ready();
    tg.expand();
    
    // Фиксируем высоту viewport, чтобы клавиатура не поджимала контент
    const setViewportHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      // Фиксируем высоту на уровне root
      document.documentElement.style.height = `${window.innerHeight}px`;
      document.body.style.height = `${window.innerHeight}px`;
    };
    
    // Устанавливаем при загрузке
    setViewportHeight();
    
    // Отключаем вертикальные свайпы для предотвращения конфликтов
    if (tg.isVersionAtLeast && tg.isVersionAtLeast('6.1')) {
      tg.disableVerticalSwipes();
    }
    
    return tg;
  }
  
  return null;
};

export const hapticFeedback = {
  light: () => {
    getTelegramWebApp()?.HapticFeedback?.impactOccurred('light');
  },
  
  medium: () => {
    getTelegramWebApp()?.HapticFeedback?.impactOccurred('medium');
  },
  
  heavy: () => {
    getTelegramWebApp()?.HapticFeedback?.impactOccurred('heavy');
  },
  
  success: () => {
    getTelegramWebApp()?.HapticFeedback?.notificationOccurred('success');
  },
  
  error: () => {
    getTelegramWebApp()?.HapticFeedback?.notificationOccurred('error');
  },
  
  warning: () => {
    getTelegramWebApp()?.HapticFeedback?.notificationOccurred('warning');
  },
  
  selection: () => {
    getTelegramWebApp()?.HapticFeedback?.selectionChanged();
  },
};

export const closeTelegramWebApp = () => {
  getTelegramWebApp()?.close();
};

